// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // Importer Firestore

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAWnR8xIKpMRxo4fyY_WQfDmAbpJE7izvA",
  authDomain: "dwag-b715a.firebaseapp.com",
  projectId: "dwag-b715a",
  storageBucket: "dwag-b715a.appspot.com",
  messagingSenderId: "566654090549",
  appId: "1:566654090549:web:ac323d30dd79871c70607c",
  measurementId: "G-7KGHCL13Z1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app); // Initialiser Firestore

// Exporter auth, db, et analytics
export { app, auth, db, analytics };
